import { CollectionName, CollectionVisibility } from "../registry/collection-registry"
import type { CollectionCreateSchema } from "../types/typesense"

export const supportingDocumentsSchema: CollectionCreateSchema = {
  name: CollectionName.SupportingDocuments,
  enable_nested_fields: true,
  fields: [
    {
      name: "id",
      type: "string",
      sort: true,
      infix: true,
      index: true,
    },
    {
      name: "status",
      type: "string",
      sort: true,
      infix: true,
      optional: true,
    },
    {
      name: "document_type",
      type: "string",
      sort: true,
      infix: true,
      optional: true,
    },
    {
      name: "document_number",
      type: "string",
      sort: true,
      infix: true,
      optional: true,
    },
    {
      name: "document_sequence",
      type: "int32",
      sort: true,
      optional: true,
    },
    {
      name: "document_reference_number",
      type: "string",
      sort: true,
      infix: true,
      optional: true,
    },
    {
      name: "primary_operator",
      type: "string",
      infix: true,
      sort: true,
      optional: true,
    },
    {
      name: "intended_operators",
      type: "string[]",
      infix: true,
      optional: true,
    },
    {
      name: "origin_country",
      type: "string",
      infix: true,
      optional: true,
    },
    {
      name: "product_description",
      type: "string",
      infix: true,
      sort: true,
      optional: true,
    },
    {
      name: "identification_marks",
      type: "string[]",
      infix: true,
      optional: true,
    },
    {
      name: "foreign_manufacture_premises",
      type: "string",
      infix: true,
      sort: true,
      optional: true,
    },
    {
      name: "foreign_premises_id",
      type: "string",
      infix: true,
      sort: true,
      optional: true,
    },
    {
      name: "nz_manufacture_premises_id",
      type: "string",
      infix: true,
      sort: true,
      optional: true,
    },
    {
      name: "nz_manufacture_premises_name",
      type: "string",
      infix: true,
      sort: true,
      optional: true,
    },
    {
      name: "production_dates",
      type: "object[]",
      infix: true,
      optional: true,
      fields: [
        {
          name: "from",
          type: "string",
          infix: true,
        },
        {
          name: "to",
          type: "string",
          infix: true,
        },
      ],
    },
    {
      name: "supporting_document_file_id",
      type: "string",
      infix: true,
      sort: true,
      index: true,
      optional: true,
    },
    {
      name: "created_at",
      type: "string",
      infix: true,
      sort: true,
      index: true,
      optional: true,
    },
    {
      name: "updated_at",
      type: "string",
      infix: true,
      sort: true,
      index: true,
      optional: true,
    },
    {
      name: "update_ts",
      type: "int64",
      sort: true,
      optional: true,
      facet: true,
      infix: true,
      index: true,
    },
    {
      name: "accessible_by",
      type: "string[]",
      optional: true,
      infix: true,
    },
  ],
  visibility: CollectionVisibility.Private,
}
